import { render, staticRenderFns } from "./BinIcon.vue?vue&type=template&id=dea776e0&scoped=true&"
import script from "./BinIcon.vue?vue&type=script&lang=js&"
export * from "./BinIcon.vue?vue&type=script&lang=js&"
import style0 from "./BinIcon.vue?vue&type=style&index=0&id=dea776e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea776e0",
  null
  
)

export default component.exports